<template>
  <div class="card card-nav-tabs">
    <div class="card-header card-header-warning">Monthly Appointments( Including uninvocied )</div>
    <div class="card-body">
      <Bar
        id="appointment-doctors-chart-id"
        :options="chartOptions"
        :data="chartData"
        v-if="!isLoading"
      />
    </div>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";
import { onMounted, ref, reactive } from "vue";
import { fetchMonthlyAppointments } from "../../api/services/reports";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);
const isLoading = ref(false);

const chartOptions = {
  responsive: true,
};
export default {
  name: "AppointmentsByMonth",
  components: { Bar },

  setup() {
    const chartData = reactive({
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      datasets: [],
    });

    const fetchMonthlyAppointmentsData = async () => {
      isLoading.value = true;
      try {
        const response = await fetchMonthlyAppointments();
        chartData.datasets = [
          {
            label: "In Patient",
            backgroundColor: "#127a4c",
            data: response.monthly_appointments.in_patient,
          },
          {
            label: "Out Patient",
            backgroundColor: "#6c8212",
            data: response.monthly_appointments.out_patient,
          },
          {
            label: "Day Case",
            backgroundColor: "#6e0a55",
            data: response.monthly_appointments.day_case,
          },
        ];

        isLoading.value = false;
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      }
    };
    onMounted(() => {
      fetchMonthlyAppointmentsData();
    });
    return {
      isLoading,
      chartData,
      chartOptions,
    };
  },
};
</script>
